import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Spinner } from '@carvana/showroom-spinner';
import {
  MyCarsContentWrapper,
  MakePaymentWrapper,
  SpinnerWrapper,
} from './MakePayment.styles';
import MakePaymentCard from './make-payment-card/MakePaymentCard';
import BackLink from '../future-packages/back-link';
import MyCarsRefreshHook from '../../utils/MyCarsRefreshHook';
import { useDualEventTracking } from '../../utils/useDualEventTracking';

const MakePayment = () => {
  const { id }: any = useParams();
  const { trackEvent } = useDualEventTracking();
  useEffect(() => trackEvent('OneTimePayment Screen', { vehicleId: id }), []);

  // Refresh Hook - Avoid selectors/ redux state access before the refresh hook and loader
  const isLoading = MyCarsRefreshHook(id);
  if (isLoading) {
    return (
      <SpinnerWrapper>
        <Spinner />
      </SpinnerWrapper>
    );
  }

  return (
    <MakePaymentWrapper>
      <MyCarsContentWrapper>
        <BackLink
          backLinkTrackEvent="one_time_cancel_button_tap"
          backLinkText="Back to Loan Details"
          backLinkRoute={`/loan-detail/${id}`}
        />
        <MakePaymentCard vehicleId={id} />
      </MyCarsContentWrapper>
    </MakePaymentWrapper>
  );
};

export default MakePayment;
